// 3rd party
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

// modules
import { MaterialModule } from 'app/shared/material/material.module';
import { ComponentsModule } from 'app/shared/components/components.module';

// components
import { SampleListComponent } from 'app/assays/samples/sample-list/sample-list.component';
import { SampleComponent } from 'app/assays/samples/sample/sample.component';
import { AssayListComponent } from 'app/assays/assay-list/assay-list.component';
import { AssayComponent } from 'app/assays/assay/assay.component';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    MaterialModule,
    RouterModule,
    ComponentsModule,
    TranslateModule,
    PdfJsViewerModule,
  ],
  declarations: [
    SampleListComponent,
    SampleComponent,
    AssayListComponent,
    AssayComponent
  ],
  providers: []
})
export class AssaysModule { }



// WEBPACK FOOTER //
// ./src/app/assays/assays.module.ts